<template>
  <v-card>
    <v-toolbar card dense color="transparent">
      <v-toolbar-title><h4>{{$t('members._today_data_')}}: {{this.members.length}}</h4></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>more_vert</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <template>
        <v-data-table
          :headers="headers"
          :items="members"
          class="elevation-0"
          :pagination.sync="pagination"
        >
          <template slot="items" slot-scope="props">
            <tr @click="editItem(props.item)" style="cursor: pointer">
            <td>
              <v-avatar size="36px">
                <img :src="props.item.imageUrl" :alt="props.item.firstName" />
              </v-avatar>
            </td>
            <td>{{ props.item.firstName }} {{ props.item.lastName }}</td>
            <td class="text-xs-left">{{ props.item.phone }}</td>
            <td class="text-xs-left">{{ props.item.accessCode }}</td>
            <td class="text-xs-left">{{ props.item.role }}</td>
            <td class="text-xs-left">{{ props.item.createdBy }}</td>
            <td class="text-xs-left">{{ props.item.createdDate }}</td>
               <td class="text-xs-right">
               <v-btn @click.stop="deleteItem(props.item)" flat icon color="grey">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
                 <td class="text-xs-right">
               <v-btn @click.stop="editItem(props.item)" flat icon color="grey">
                 <v-icon>edit</v-icon>
              </v-btn>
            </td>
            </tr>
          </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>

<script>
/* eslint-disable */ 
import { db } from '@/api/firebaseInit';
import firebase from 'firebase';
export default {
  data () {
    return {
      // members: [],
      loading: false,
      members: [],

      headers: [
          {
            text:this.$t('members._photo_'),
            align: 'left',
            sortable: false,
            value: 'imageUrl'
          },
          { text:this.$t('members._fullname_'), value: 'lastName' },
          { text:this.$t('members._phone_'), value: 'phone' },
          { text:this.$t('members._access_code_') , value: 'accessCode' },
          { text:this.$t('members._rule_'), value: 'role' },
          { text:this.$t('members._createdBy_') , value: 'createdBy' },
          { text:this.$t('members._createdDate_') , value: 'createdDate' },
            {
            text: this.$t('members._delete_'),
            align: 'left',
            sortable: false,
            value: ''
          },
           {
            text: this.$t('members._edit_'),
            align: 'left',
            sortable: false,
            value: ''
          }
        ],

        pagination: {
          sortBy: 'createdDate',
          'descending': true,
          rowsPerPage: '100'
        },
    };
  },
   firestore () {
    return {
        // Collection
        members: db.collection('Census').where('createdDate', ">=", this.today) 
    }
  },
  created() {
    
  },
  computed: {
     today () {
     let today = (new Date());
      today = new Date(today.setHours(0,0,0,0));
      return today
    }
  },
  methods: {
        editItem(item) {
      this.$store.commit('currentMemberId', item.id);
       this.fetchCurrentMember(item.id)
      // this.$store.commit('currentMemberId', item.id)
      //   // this.$store.dispatch('fetchCurrentMember', item.id)
      //   this.$router.push('/form/newmember')
      },

    // for future use;
    deleteItem(item) {
         const index = this.members.findIndex(x => x.id == item.id )
      
        if (confirm(this.$t('members._confirm_delete_'))) {
          this.members.splice(index, 1)
          this.$store.dispatch('deleteMember', item.id)
        }
      },
       fetchCurrentMember (payload) {
     
      db.collection('Census').doc(payload)
      .get()
      .then((doc) => {
        const form = {
             id: doc.id,
             imageUrl: doc.data().imageUrl,
             firstName: doc.data().firstName,
             lastName: doc.data().lastName,
             posteName: doc.data().posteName,
             accessCode: doc.data().accessCode,
             role: doc.data().role,
             phone: doc.data().phone,
             email: doc.data().email,
             dateOfBirth: doc.data().dateOfBirth,
             address: doc.data().address,
             gender: doc.data().gender,
             consent: doc.data().consent,
             city: doc.data().city,
             postalCode: doc.data().postalCode,
             isWithChildren: doc.data().isWithChildren,
             hasSmartPhone: doc.data().hasSmartPhone,
             noPhoneReason: doc.data().noPhoneReason,
             isBuyPhoneReady: doc.data().isBuyPhoneReady,
             maritalStatus: doc.data().maritalStatus,
             noVolunteerReason: doc.data().noVolunteerReason,
             isVolunteer: doc.data().isVolunteer,
             hasChildren: doc.data().hasChildren,
             volunteerFrequency: doc.data().volunteerFrequency,
             niveauScolaire: doc.data().niveauScolaire,
             churchName: doc.data().churchName,
             churchAttendance: doc.data().churchAttendance,
             memberSince: doc.data().memberSince,
             sermonTimeSpent: doc.data().sermonTimeSpent,
             isreferralReady: doc.data().isreferralReady,
             noReferralReason: doc.data().noReferralReason,
             isVolunteerReady: doc.data().isVolunteerReady,
             noVolunteerReason: doc.data().noVolunteerReason,
             volunteerTime: doc.data().volunteerTime,
             noDonationReason: doc.data().noDonationReason,
             donation: doc.data().donation,
             isDimeContribution: doc.data().isDimeContribution,
             isDonationReady: doc.data().isDonationReady,
             // dimeAmount: doc.data().dimeAmount,
             dime: doc.data().dime,
             dimeType: doc.data().dimeType,
             isOffrandeContribution: doc.data().isOffrandeContribution,
             // offrandeAmount: doc.data().offrandeAmount,
             offrandeType: doc.data().offrandeType,
             offrande: doc.data().offrande,
             isGraceContribution: doc.data().isGraceContribution,
             // graceDonationAmount: doc.data().graceDonationAmount,
             graceContributionType: doc.data().graceContributionType,
             isWorking: doc.data().isWorking,
             createdDate: doc.data().createdDate,
             isWorkReady: doc.data().isWorkReady,
             notAvailableReason: doc.data().notAvailableReason,
             isEducationReady: doc.data().isEducationReady,
             education: doc.data().education,
             isHouseOwner: doc.data().isHouseOwner,
             houseOwnerSince: doc.data().houseOwnerSince,
             isRenting: doc.data().isRenting,
             jobSkills: doc.data().jobSkills,
             jobSearch: doc.data().jobSearch,
             jobType: doc.data().jobType,
             availableTime: doc.data().availableTime,
             jobDisponibility: doc.data().jobDisponibility,
             timeOnCurrentJob: doc.data().timeOnCurrentJob,
             jobPosition: doc.data().jobPosition,
             numberOfJobs: doc.data().numberOfJobs,
             jobRepartition: doc.data().jobRepartition,
             jobWeeklyHours: doc.data().jobWeeklyHours,
             jobTravelDistance: doc.data().jobTravelDistance,
             homeTravelDistance: doc.data().homeTravelDistance,
             jobTravelMode: doc.data().jobTravelMode,            
             jobTravelCost: doc.data().jobTravelCost,
             jobTravelTime: doc.data().jobTravelTime,
             jobMonthlyPay: doc.data().jobMonthlyPay
        }  
         if (doc.data().imageUrl === "./src/assets/avatar.png" ) {
           form.imageUrl = memberPhoto;
         } else {
           this.$store.commit('memberPhoto', form.imageUrl)
         }
         if (
          doc.data().isBuyPhoneReady === null ||
          doc.data().isBuyPhoneReady === undefined
         ) {
           form.isBuyPhoneReady = false;
         }
         if (
          doc.data().isVolunteerReady === null ||
          doc.data().isVolunteerReady === undefined
         ) {
           form.isVolunteerReady = "Non";
         }
         if (
          doc.data().volunteerTime === null ||
          doc.data().volunteerTime === undefined
         ) {
           form.volunteerTime = {
            nombre: 0,
            frequency: 'Par jour'
           }
         }
          if (
          doc.data().houseOwnerSince === null ||
          doc.data().houseOwnerSince === undefined
         ) {
           form.houseOwnerSince = {
            nombre: 0,
            frequency: 'Par jour'
           }
          }
          if (
          doc.data().offrande === null ||
          doc.data().offrande === undefined
         ) {
           form.offrande = {
            nombre: 0,
            frequency: 'Par jour'
           }
          }
           if (
          doc.data().donation === null ||
          doc.data().donation === undefined
         ) {
           form.donation = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
           if (
          doc.data().dime === null ||
          doc.data().dime === undefined
         ) {
           form.dime = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
          if (
          doc.data().timeOnCurrentJob === null ||
          doc.data().timeOnCurrentJob === undefined
         ) {
           form.timeOnCurrentJob = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
          if (
           
          doc.data().jobSearch === null ||
          doc.data().jobSearch === undefined
         ) {
           form.jobSearch = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
           if (
          doc.data().graceDonation === null ||
          doc.data().graceDonation === undefined
         ) {
           form.graceDonation = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
          if (
          doc.data().jobDisponibility === null ||
          doc.data().jobDisponibility === undefined
         ) {
           form.jobDisponibility = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
         if (
          doc.data().education === null ||
          doc.data().education === undefined
         ) {
          form.education = {
            nombre: 0,
            frequency: 'Par jour'
           }
         }
         if (
          doc.data().numberOfKids === null ||
          doc.data().noPhoneReason === undefined
         ) {
           form.numberOfKids = 0;
         }
         if (
          doc.data().noReferralReason === null ||
          doc.data().noReferralReason === undefined
         ) {
           form.noReferralReason = 'Pas de raison';
         }
         if (
          doc.data().noDonationReason === null ||
          doc.data().noDonationReason === undefined
         ) {
           form.noDonationReason = 'Pas de raison';
         }
         if (
          doc.data().notAvailableReason === null ||
          doc.data().notAvailableReason === undefined
         ) {
           form.notAvailableReason = 'Pas de raison';
         }
         form.consent = true
          this.$store.commit('currentMember', form)
        })
      this.$router.push('/form/newmember')
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/widgets/TodayList.vue